import "@common/jquery.ext";
import {menu} from "@common/menu";
import {ajax} from "@common/ajax";
import {message} from "@common/message";
import {util} from "@common/util";
import {orderTemplate} from "@components/template";

$(() => {
    // init verify
    initVerify();
});

//-------------------------------------
// Verify
//-------------------------------------
const initVerify = (): void => {
    // events
    $("#odNo").enter("#email");
    $("#email").enter(doVerify);
    $("#btnSubmit").click(doVerify);
    $("#btnCancel").click(menu.goLogin);
}

const doVerify = (): void => {
    // hide message
    hideVerifyMessage();
    // check valid
    if ($("#odNo").trim().val() === "") {
        showVerifyMessage("주문확인번호를 입력해 주세요.");
        $("#odNo").focus();
    }
    else if ($("#email").trim().val() === "") {
        showVerifyMessage("이메일을 입력해 주세요.");
        $("#email").focus();
    }
    else {
        ajax.formSubmit({
            url: "./verifyProc.do",
            form: "#frmVerify",
            func: {
                success: (result: any) => openOrder(result.taskId),
                error: (result: any) => {
                    let message = ajax.getErrorMessage(result, [
                        { code: 1, message: "일치하는 정보를 찾을 수 없습니다." },
                    ]);
                    showVerifyMessage(message);
                }
            }
        });
    }
}

const showVerifyMessage = (message: string): void => {
    $("#verifyMessage").html(message).show();
}

const hideVerifyMessage = (): void => {
    $("#verifyMessage").html("");
}

//-------------------------------------
// Order
//-------------------------------------
const openOrder = (taskId: any): void => {
    // open
    $("#viewVerify").addClass("hide");
    $("#viewOrder").removeClass("hide");
    // scroll top
    $("html, body").moveScrollTop();
    // get order info
    getInfo(taskId);
}

const getInfo = (taskId: any): void => {
    // show loading
    message.loading();
    // parameters
    const params = $("#frmVerify").serializeObject();
    params.taskId = taskId;
    // get info
    ajax.jsonData({
        url: "./getInfo.do",
        data: util.jsonToQuery(params),
        func: {
            success: (result: any) => {
                setOrderInfo(result);
                setOrderList(result);
                setShippingInfo(result);
                // hide loading
                message.close();
            },
            error: (result: any) => {
                ajax.alertErrorMessage(result, [
                    { code: 1, message: "정보를 찾을 수 없습니다." }
                ]);
            }
        }
    });
}

const setOrderInfo = (result: any): void => {
    const infoObj = $("#orderInfo");
    // clear
    infoObj.find(".txt-od, txt-cs").empty();
    // set order list
    if (!!result) {
        // order info
        if (!!result.info) {
            infoObj.find(".txt-od").setDataText(result.info);
            // events
            if (result.info.aprvYn === "Y") {
                $("#btnForm").removeClass("hide").on("click", result.info, openForm);
            }
        }

        // customer info
        if (!!result.customerInfo) {
            infoObj.find(".txt-cs").setDataText(result.customerInfo);
        }
    }
}

const setOrderList = (result: any): void => {
    // clear
    const listObj = $("#orderList").empty();
    // set order list
    if (!!result && !!result.info && !util.isEmptyArray(result.orderList)) {
        $.each(result.orderList, (index: number, info: any) => {
            // add order
            const orderObj = $(`
                <li data-od-no="${info.odNo}">
                    ${orderTemplate.list(info)}
                </li>
            `);
            orderObj.find(".order-info").addClass("cur-none");
            // append
            listObj.append(orderObj);
        });
        // summary
        listObj.append(orderTemplate.summary(result.info));
        // count
        $("#orderCount").html(`${result.orderList.length}`);
    }
}

const setShippingInfo = (result: any): void => {
    const infoObj = $("#shipInfo");
    // clear
    infoObj.find(".txt-od").empty();
    // set info
    if (!!result && !!result.info) {
        // set data
        infoObj.find(".txt-od").setDataText(result.info);
        // direct
        if (result.info.shipDirectYn === "Y") {
            infoObj.find("[data-column=rcpntNm]").append(`<span class="shipping-direct ml5">직배송</span>`);
        }
    }
}

const openForm = (event: any): void => {
    const info = event.data;
    menu.openForm(`formType=O&formNo=${info.ctrNo}`);
}